import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { ReportsState } from 'src/app/reports/reports.state';
import * as constants from 'src/constant.json';

@Component({
  selector: 'app-search-by-address',
  templateUrl: './search-by-address.component.html',
  styleUrls: ['./search-by-address.component.scss']
})
export class SearchByAddressComponent implements OnInit {
 @Output() propertySelected = new EventEmitter<any>();
  constructor(private formBuilder: FormBuilder, private snackbar: MatSnackBar,
    private reportsState :ReportsState
  ) { }

  searchAddressForm: FormGroup;
  constant: any = constants; 
  upgradeSnackbar: MatSnackBarRef<any>;

  initialValues: {};
  onDestroyNotifier$ = new Subject();

  ngOnInit(): void {
    this.searchAddressForm = this.formBuilder.group({
      streetNumber: null,
      streetName: null,
      unitNumber: null,
      city: null,
      state: null,
      zip: null,
    });
    this.initialValues = this.searchAddressForm.value;
  }

  addressSearch() {
    let formValues = this.searchAddressForm.value;

    if (formValues.streetNumber || formValues.streetName) {
      if ((formValues.city && formValues.state) || formValues.zip) {
        let addressObj: any = {
          StreetNumber: formValues.streetNumber,
          StreetName: formValues.streetName,
          City: formValues.city,
          State: formValues.state,
          Zip: formValues.zip,
          ListingsOnly: true,
          pagenumber: 1,
          pagesize: 20,
        };
        let property = this.filterInputJson(addressObj);
         this.propertySelected.emit(property);
        this.reportsState.searchPropertyValue = this.filterInputJson(addressObj);
      } else {
        this.openSnackbar('City and State or Zip is mandatory', false);
      }
    } else {
      this.openSnackbar('StreetNumber or StreetName is mandatory', false);
    }
  }

  resetSearchFilter() {
    this.searchAddressForm.reset(this.initialValues);

  }

  ngOnDestroy(): void {
     this.searchAddressForm.reset();
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
   
  }

  openSnackbar(upgradeMsg, success = false) {
    this.upgradeSnackbar = this.snackbar.open(upgradeMsg, 'Dismiss', {
      duration: 5000,
      panelClass: [success ? 'snackbar-success' : 'snackbar-error'],
      verticalPosition: 'top',
    });
  }

  filterInputJson(obj) {
    Object.keys(obj).forEach((key) => {
      if (obj[key] == null) {
        delete obj[key];
      }
    });
    return obj;
  }
}
